
import "./text-area-v1"
import "./input-v1"
import "./select-box-v2"
import "./checkbox-v1"
import { validateInput } from '@yggdrasil/Utils/inputValidator'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class AppointmentSchedulerV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}


  mount() {
    const root = this.element

    function setupHostDropdown() {
      const el = root.querySelector("#hostDropdown")
      if (!el) return

      const button = root.querySelector('#hostDropdown button')
      const options = root.querySelector('#hostDropdown ul')
      button.addEventListener('click', () => {
        options.classList.remove("hidden")
      })
    }

    const processCronofyResponse = (data) => {
      updateSlotSummary(data)
      updateForm(data)
      toggleForm(data)
    }

    const updateSlotSummary = (data) => {
      const slotInfo = root.querySelector('#slotInfo')
      const timeEl = root.querySelector("#timeString")
      const zoneEl = root.querySelector("#zoneString")

      const slotDate = new Date(data.slot.start)
      // locales such as `ja` are good on their own, but simple `en` requires a nudge – is it `en-ca` or `en-gb?`
      // let's make sure we use en-us for all english locales for now, as we don't have notion of region just yet.
      const locale = this.__locale !== 'en' ? this.__locale : 'en-us'
      const timeString = slotDate.toLocaleString(locale, {timezone: data.tzid})
      const month = slotDate.toLocaleString(locale, {timezone: data.tzid, month: 'long'})
      const [date,time] = timeString.split(", ")
      const [_month, day, year] = date.split("/")

      timeEl.innerText = `${time.slice(0, time.lastIndexOf(":"))}, ${day} ${month} ${year}`
      zoneEl.innerText = data.tzid

      slotInfo?.classList?.remove('hidden')
    }

    const updateForm = (data) => {
      root.querySelector('#appointment_schedule_request_start_on').value = data.slot.start
      root.querySelector('#appointment_schedule_request_end_on').value = data.slot.end
      root.querySelector('#appointment_schedule_request_tzid').value = data.tzid
    }

    function toggleForm(data) {
      const cal = root.querySelector('[data-cronofy-picker]')
      const form = root.querySelector('#formContainer')

      cal?.classList?.add('hidden')
      form?.classList?.remove('hidden')
    }

    // The date/time picker is rendered by Cronofy, not by this template, so the
    // texts it owns have to be handed over as translation overrides — otherwise
    // they only ever show up in the editor's static preview.
    //
    // Cronofy resolves its locale from the visitor's browser, so an override has
    // to be repeated across every locale it ships with to be sure it wins. That
    // also means an override wipes out Cronofy's own translation of that string,
    // so we only send the texts the page author actually changed.
    const cronofyLocales = ['ar', 'cs', 'cy', 'de', 'en', 'es', 'fr', 'fr-CA', 'he', 'it', 'ja', 'nl', 'pl', 'pt-BR', 'ru', 'sv', 'tr', 'zh-CN']

    const buildCronofyTranslations = () => {
      const texts = this.appointmentSchedulerTexts ?? {}
      const allDefaults = this.cronofyTextDefaults ?? {}
      // The editor seeds these texts in the author's UI language, so compare
      // against the defaults for the locale the node was created in.
      const defaults = allDefaults[this.__locale] ?? allDefaults.en ?? {}
      // Cronofy appends its own colon to the time zone and duration labels.
      const withoutTrailingColon = (text) => text.replace(/\s*:\s*$/, '')

      const customized = (key) => {
        const text = texts[key]
        if (typeof text !== 'string' || text.trim().length === 0) return null
        return text === defaults[key] ? null : text
      }

      const core = {}
      const dateTimePicker = {}

      const timeZone = customized('timeZone')
      const duration = customized('duration')
      const minutes = customized('minutes')
      const selectTime = customized('selectTime')
      const previousMonth = customized('navigateToPreviousMonth')
      const nextMonth = customized('navigateToNextMonth')

      if (timeZone) core.time_zone = withoutTrailingColon(timeZone)
      if (duration) dateTimePicker.duration_label = withoutTrailingColon(duration)
      if (minutes) dateTimePicker.minutes = minutes
      if (selectTime) dateTimePicker.select_time_slot = selectTime
      if (previousMonth) dateTimePicker.nav_previous_month = previousMonth
      if (nextMonth) dateTimePicker.nav_next_month = nextMonth

      if (Object.keys(core).length === 0 && Object.keys(dateTimePicker).length === 0) return undefined

      const translations = {}
      cronofyLocales.forEach((locale) => {
        translations[locale] = { core: { ...core }, date_time_picker: { ...dateTimePicker } }
      })
      return translations
    }

    if (this.requestFetcher){
      this.requestFetcher.abort()
    }
    this.requestFetcher = null
    this.requestFetcher = new globalThis.CFFetcher()
    const fetchUrl = `/user_pages/api/v1/appointments/event_types/${this.event_type.id}/calendar_config`
    this.requestFetcher.fetch(fetchUrl,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          host_id: this.event_type?.selected_host?.id,
        })
      }
    )
    .then((response) => response.json())
    .then((data) => {
      // Cronofy only takes an element id, and a page can hold more than one copy of this
      // element (Checkout/V2 renders its slots once per checkout state), so give each copy its own.
      const picker = root.querySelector('[data-cronofy-picker]')
      picker.id = `cronofy-date-time-picker-${Math.random().toString(36).slice(2, 10)}`

      this.cronofy = CronofyElements.DateTimePicker({
        element_token: data.cronofy.element_token,
        target_id: picker.id,
        availability_query: JSON.parse(data.cronofy.availability_query_json),
        styles: {
          prefix: 'cf2',
          colors: {
            buttonActive: data.cronofy.active_color,
            buttonHover: data.cronofy.hover_color,
            buttonConfirm: data.cronofy.confirm_color,
          },
        },
        tzid: data.cronofy.tzid,
        translations: buildCronofyTranslations(),
        callback: (res) => {
          if (res?.notification?.type !== 'slot_selected') return

          processCronofyResponse(res?.notification)
        }
      })
    })

    setupHostDropdown()

    const errors = {}
    const updateErrorDisplay = () => {
      const errorList = root.querySelector('ul.errorList')
      errorList.innerHTML = ''
      if(Object.keys(errors).length === 0) {
        errorList.classList.add('hidden')
      } else {
        for(const key in errors){
          const li = document.createElement("li")
          li.appendChild(document.createTextNode(errors[key]))
          errorList.appendChild(li)
        }
        errorList.classList.remove('hidden')
      }
    }

    const validateOnBlur = (input, inputName) => {
      const result = validateInput(input, {validateAsEmail: input.type === 'email' || input.name?.match(/email/)})
      delete errors[inputName]
      input.style.color = 'black'
      if (result === false) {
        const fieldName = inputName.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
        errors[inputName] = `${fieldName} ${this.appointmentSchedulerTexts.invalid}`
        input.style.color = 'red'
      }
      updateErrorDisplay()
    }

    const inputs = root.querySelectorAll('.appointment_schedule_request_field:not(.hidden)')
    inputs.forEach((input) => {
      input.addEventListener('blur', () => validateOnBlur(input, input.name))
    })
    root.querySelector('a[href="#submit-form"]').addEventListener('click', (event) => {
      inputs.forEach((i) => {
        i.dispatchEvent(new Event('blur'))
      })
      root.querySelectorAll(".guest-input").forEach((i) => {
        i.dispatchEvent(new Event('blur'))
      })
    })

    const additionalFields = root.querySelector('.additional-fields-container')
    const addCommentsButton = root.querySelector('.add-comments a')
    const addGuestButton = root.querySelector('.add-guest a')
    const links = root.querySelector('.add-links')
    const commentsContainer = root.querySelector('.comments-container')
    const guestsContainer = root.querySelector('.guests-container')
    const guestEmailTemplate = root.querySelector('.guest-email-template')

    addCommentsButton.addEventListener('click', (evt) => {
      evt.preventDefault()

      commentsContainer.classList?.remove('hidden')
      addCommentsButton.classList?.add('hidden')
    })

    addGuestButton.addEventListener('click', (evt) => {
      evt.preventDefault()
      const inputCount = root.querySelectorAll('.guest-input').length

      const guestInputContainer = guestEmailTemplate.cloneNode(true)
      guestInputContainer.classList.remove('guest-email-template')
      guestInputContainer.classList.add('guest-email')

      const guestInput = guestInputContainer.querySelector('input')
      guestInput.type = 'email'
      guestInput.name = `guest_email_${inputCount + 1}`
      guestInput.classList.add('guest-input')
      guestInput.addEventListener('blur', () => validateOnBlur(guestInput, guestInput.name))

      guestsContainer.appendChild(guestInputContainer)

      const removeGuestButton = guestInputContainer.querySelector('.remove-link')
      removeGuestButton.addEventListener('click', () => {
        const container = root.querySelector('.guests-container')
        console.log({removeGuestButton})
        removeGuestButton.parentElement.remove()
        delete errors[guestInput.name]
        updateErrorDisplay()
        if (guestsContainer.querySelectorAll('.guest-email').length == 0) {
          guestsContainer.classList.add('hidden')
        }
      })

      guestsContainer.classList.remove('hidden')
    })
  }



}

registerComponent('AppointmentScheduler/V1', AppointmentSchedulerV1)
window["AppointmentSchedulerV1"] = AppointmentSchedulerV1

